import React, { useState, useEffect } from 'react';
import './ContentRight.css';
import { Mic2, Sliders, School } from 'lucide-react';

function ContentRight() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const images = [
    '/img/slider-studio/1.jpeg',
    '/img/slider-studio/2.jpeg',
    '/img/slider-studio/3.jpeg',
    '/img/slider-studio/4.jpeg',
    '/img/slider-studio/5.jpg',
    '/img/slider-studio/aussen.jpg',
    '/img/slider-studio/band.jpeg',
    '/img/slider-studio/drum.png',
    '/img/slider-studio/mike.png',
    '/img/slider-studio/perspektive.png'
  ];

  // Auto-play: Alle 3 Sekunden weiter
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        handleNext();
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [currentIndex, isPaused]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section id="studio" className="content-right">
      <div className="content-text">
        <h2>Wenn du das Studio betrittst, findest du:</h2>
        <ul style={{listStyleType: 'none', marginLeft: '20px'}}>
          <li style={{display: 'flex', gap: '12px', marginBottom: '16px'}}>
          <School size={55} strokeWidth={1.5} style={{flexShrink: 0, marginTop: '2px'}} className='iconList'/>         
            <span>Drei Aufnahmeräume mit Tageslicht<br /> und akustischer Trennung</span>
          </li>
          <li style={{display: 'flex', gap: '12px', marginBottom: '16px'}}>
          <Mic2 size={55} strokeWidth={1.5} style={{flexShrink: 0, marginTop: '2px'}} className='iconList'/>
          <span>Einen feinen Raum für intime <br />Live-Konzerte und kleine Sessions</span>
          </li>
          <li style={{display: 'flex', gap: '12px', marginBottom: '16px'}}>
            <Sliders size={55} strokeWidth={1.5} style={{flexShrink: 0, marginTop: '2px'}} className='iconList'/>
            <span>Technik vom Feinsten – Recording <br />und Mixing auf höchstem Niveau</span>
          </li>
        </ul>
        <br />
        <p>
          Hier gibt's auch Meinung, Feedback und ehrliche Ratschläge. Der Tonmeister hört zu – und mischt sich, wenn es passt, auch aktiv ein.
        </p>
        <p>
          Und sollte es größer werden? Orchester, Bigband, Flügel außer Haus? Kein Problem. Mit mobilem Equipment sind Aufnahmen fast überall möglich. Außerdem gibt es eine Zusammenarbeit mit dem Frog Studio – dort steht einer der besten Steinway-Flügel Hamburgs bereit.
        </p>
        <p>
          Also: Komm vorbei, trink 'nen Kaffee (vielleicht mit Franzbrötchen), erzähl von deiner Musik – und wir planen gemeinsam, in aller Ruhe, deine Produktion.<br />
          (Das Rätsel um den Namen Milchkettenmusik lösen wir dann bei Gelegenheit … 😉)
        </p>
        <button className="btn-primary" onClick={scrollToContact}>Kontakt aufnehmen</button>
      </div>
      <div 
        className="content-image"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="slider-container">
          {images.map((image, index) => (
            <div
              key={index}
              className={`slider-image ${index === currentIndex ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${image})`,
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
              }}
            />
          ))}
          <button className="slider-arrow slider-arrow-left" onClick={handlePrev}>‹</button>
          <button className="slider-arrow slider-arrow-right" onClick={handleNext}>›</button>
          <div className="slider-dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContentRight;

